// extracted by mini-css-extract-plugin
export var Description = "index-module--Description--fb051";
export var EmailSection = "index-module--EmailSection--07419";
export var Title = "index-module--Title--bbc9a";